import ivclass from '@invideoio/web-shared/Modules/IVClass';

import SeeAllLink from '@components/see-all-link';
interface SubHeadingProps {
  title: string;
  viewAllURL?: string;
}

function SubHeading({ title, viewAllURL }: SubHeadingProps) {
  return (
    <div
      className={ivclass(
        'iv-flex iv-justify-between iv-items-baseline',
        'iv-mb-[67px] md:iv-mb-[32px] sm:iv-mb-15',
        'iv-text-body-2xl iv-font-semibold ',
      )}
    >
      <div
        className={ivclass(
          'iv-text-heading-2xl md:iv-text-heading-m sm:iv-text-[36px]',
          'sm:iv-leading-[42px]',
          'iv-font-extrabold',
          'iv-pl-[56px] lg:iv-pl-[64px] md:iv-pl-[40px] sm:iv-pl-25',
        )}
      >
        {title}
      </div>
      <div className={ivclass('sm:iv-hidden')}>
        {viewAllURL && <SeeAllLink viewAllURL={viewAllURL} />}
      </div>
    </div>
  );
}
export default SubHeading;
